import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import classnames from 'classnames'
import sectionFieldsetStyles from './sectionFieldset.styles'

const useStyles = makeStyles(sectionFieldsetStyles)

const SectionFieldset = ({ label, children, className, style, contentGap }) => {
  const classes = useStyles()

  return (
    <div className={classnames(classes.root, className)} style={style}>
      <span className={classes.label}>{label}</span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: contentGap }}>{children}</div>
    </div>
  )
}

SectionFieldset.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  contentGap: PropTypes.number,
}

SectionFieldset.defaultProps = {
  contentGap: 18,
}

export default SectionFieldset
